import { render, staticRenderFns } from "./trim-list-item.vue?vue&type=template&id=3d93d126&scoped=true"
import script from "./trim-list-item.vue?vue&type=script&setup=true&lang=ts"
export * from "./trim-list-item.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d93d126",
  null
  
)

export default component.exports